import React from 'react';
import { ANNOUNCEMENT_CATEGORY } from 'types';
import { Tooltip } from 'carbon-components-react';
import {
  Information24,
  WarningAlt24,
  Help24,
  CheckmarkOutline24,
  FaceSatisfied24,
  FaceDissatisfied24,
  EventSchedule24,
  Coronavirus24,
  Bullhorn24,
  Pin24,
  Tools24,
  Tag24,
  Idea24,
  Clean24,
  Warning24
} from '@carbon/icons-react';

const Icon: React.FC<{
  icon?: string;
  category: string;
  type: string;
  openTooltip: boolean;
  handleTooltipOver: any;
  organisations: any;
}> = ({
  icon,
  category,
  type,
  openTooltip,
  handleTooltipOver,
  organisations
}) => {
  if (type === 'Member') {
    const noOfOrgsToShow = 3;
    const totalOrgs = organisations.length;
    const topThreeOrgs = organisations.slice(0, noOfOrgsToShow);
    const more = totalOrgs - noOfOrgsToShow;

    const Warning24Icon = React.forwardRef(() => (
      <Information24 className="help-icon" />
    ));
    return (
      <Tooltip
        triggerText={''}
        align="start"
        open={openTooltip}
        onChange={handleTooltipOver}
        renderIcon={Warning24Icon}
        className={'custom-tooltip-size'}
      >
        <div id="tooltip-body">
          {topThreeOrgs.map((org: any) => {
            return (
              <p key={`${org.utilityId}`}>{`${org.name} (${org.utilityId})`}</p>
            );
          })}
          {more > 0 && <p>and {more} more ...</p>}
        </div>
      </Tooltip>
    );
  }

  switch (icon) {
    case 'Information': {
      return <Information24 />;
    }
    case 'WarningAlt': {
      return <WarningAlt24 />;
    }
    case 'Help': {
      return <Help24 />;
    }
    case 'CheckmarkOutline': {
      return <CheckmarkOutline24 />;
    }
    case 'FaceSatisfied': {
      return <FaceSatisfied24 />;
    }
    case 'FaceDissatisfied': {
      return <FaceDissatisfied24 />;
    }
    case 'EventSchedule': {
      return <EventSchedule24 />;
    }
    case 'Bullhorn': {
      return <Bullhorn24 />;
    }
    case 'Coronavirus': {
      return <Coronavirus24 />;
    }
    case 'Clean': {
      return <Clean24 />;
    }
    case 'Idea': {
      return <Idea24 />;
    }
    case 'Pin': {
      return <Pin24 />;
    }
    case 'Tag': {
      return <Tag24 />;
    }
    case 'Tools': {
      return <Tools24 />;
    }
    case 'Warning': {
      return <Warning24 />;
    }
    default: {
      if (category === ANNOUNCEMENT_CATEGORY.INFORMATION) {
        return <Idea24 />;
      } else {
        return <Warning24 />;
      }
    }
  }
};

export default Icon;
